import React from "react";
import { CreditCard, Banknote } from "lucide-react";

/**
 * Compact "Payment on completion" strip used across the site.
 * Placed above booking form + on pricing page.
 */
export default function PaymentStrip({ compact = false }) {
  return (
    <div
      data-testid="payment-strip"
      className={`rounded-2xl bg-white border-2 border-[#0F2E52] shadow-sm px-4 md:px-6 ${
        compact ? "py-3 md:py-4" : "py-4 md:py-5"
      } flex items-center gap-3 md:gap-4`}
    >
      <div className="flex items-center gap-1.5 md:gap-2 shrink-0">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-[#F0F7E8] border border-[#C7DDA6] grid place-items-center">
          <CreditCard className="w-5 h-5 md:w-6 md:h-6 text-[#0F2E52]" strokeWidth={2.4} />
        </div>
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-[#F0F7E8] border border-[#C7DDA6] grid place-items-center">
          <Banknote className="w-5 h-5 md:w-6 md:h-6 text-[#0F2E52]" strokeWidth={2.4} />
        </div>
      </div>
      <div className="min-w-0">
        <p className="font-[Work_Sans] font-black text-[#0F2E52] text-sm md:text-lg leading-tight">
          Payment by EFTPOS or Cash
        </p>
        <p className="text-xs md:text-sm font-semibold text-[#475569] leading-snug">
          Paid upon completion of the job. No online payments — no cards on file.
        </p>
      </div>
    </div>
  );
}
